import React from "react";
import autoBind from 'react-autobind';
import { Layout, Row, Col } from 'antd';
//
import Logo from '../commonComponents/Logo';
import CustomComponent from "@/components/CustomComponent";
import CommonLoadingView from "../commonComponents/CommonLoadingView";
import CommonLoginForm from './Forms/CommonLoginForm';
import CommonBoxLinks from '../commonComponents/CommonBoxLinks';
//resources
import "@/stylesheets/CommonLogin.scss";
//
import config from "@/config/config";
import Utils from "@/components/Utils";
//
export default class CommonLoginView extends CustomComponent {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = { isLoading: false};
    this.props.app.sessionDidFailLoadHandler = this.sessionDidFailLoadHandler;
    this.props.app.sessionExternalProviderLoadedHandler = this.sessionExternalProviderLoadedHandler
  }
  componentDidMount() {
    super.componentDidMount();
    document.title = `Sign in - ${config.ApplicationName}`;
  }
  sessionDidFailLoadHandler(err) {
    if (!err) err = 'Could not load application information. Please, check your internet connection.';
    this.props.app.alertController.showErrorAlert('Error!', err);
    if (this._isMounted) this.stopLoading();
  }
  sessionExternalProviderLoadedHandler() { if (this._isMounted) this.forceUpdate(); }
  //Actions
  handleSignup(event) { this.props.app.urlManager.pushPage(config.ApplicationRoutes.register); }
  async handleLoginWithProvider(provider) {
    this.startLoading();
    await this.props.app.idm.externalProviders[`loginWith${provider}`]();
  }
  handleForgotPassword(event) {
    let param = '';
    if (this.form && this.form.form.getFieldValue('username')) {
      param = this.form.form.getFieldValue('username').trim();
    }
    this.props.app.urlManager.pushPage(config.ApplicationRoutes.resetPassword, null, param);
  }
  handleChange(event) {
    if (event.target.type == "checkbox") this.setState({ [event.target.id]: event.target.checked });
    else this.setState({ [event.target.id]: event.target.value });
  }
	async handleLogin(data){
    this.startLoading();
    //
    await this.props.app.idm.authenticator.login(data.username.trim(), data.password, null);
    //sessionLoadErrorHandler can be called
    if (this._isMounted) this.setState({isLoading: false});
	}

  //UI
  render() {
    let isLoading = this.state.isLoading || this.props.app.isAuthenticating;
    return (
      <Layout.Content className='pageContentFullScreen'>
        <CommonLoadingView isLoading={isLoading} isFixed={true} />
        <Layout.Content className='authorizationContainer'>
          <Row type="flex" justify="center" align="middle" className='authLogoRow'><Col align="center"> <Logo /> </Col></Row>
          <Row type="flex" justify="center" align="middle" >
            <Col span={6} className='authorizationBoxContainer'>
              <div className='authorizationBox'>
                <Row>
                  <Col align="center">
                    <h5 className="authorizationBoxTitle">Sign in</h5>
                    <h6 className="authorizationBoxDescription">Use your {config.ApplicationName} Account</h6>
                  </Col>
                </Row>
                <CommonLoginForm app={this.props.app} onLogin={this.handleLogin} onSingup={this.handleSignup}
                           onForgot={this.handleForgotPassword} {...Utils.propagateRef(this, 'form')} 
                           onProviderLogin={this.handleLoginWithProvider}/>
              </div>
            </Col>
          </Row>
          <CommonBoxLinks width={340}/>
        </Layout.Content>
      </Layout.Content>
    );
  }
}
